// Translation strings for Arabic edition (Egypt).
// Only regions with language="Arabic" trigger the ar strings.

export const EN = {
  frontPage: "Front Page",
  weather: "Weather",
  onTheWire: "On the Wire",
  chartFallback: "Top 5 Songs",
  atCinema: "At the Cinema",
  onTheTube: "On The Tube",
  watchTrailer: "Watch trailer",
  watchClip: "Watch a clip",
  whereToStream: "Where to stream",
  aboutFilm: "About",
  onTheShelf: "On The Shelf",
  ambient: "Ambient",
  gasPrice: "Gas Price",
  slangOfDay: "Slang of the Day",
  soundtrack: "▶ Soundtrack of the Day",
  soundtrackHint: "Top 3 — tap to play",
  nowPlaying: "Now Playing — #1 of the week",
  openSpotify: "Open in Spotify ↗",
  listen: "Listen ↗",
  search: "Search ↗",
  backToDesk: "Back to Desk",
  reprint: "Reprint",
  share: "Share Snapshot",
  media: "Media",
  mediaTitle: "Newsreel & Photographs",
  mediaHint: "Photographs from Wikipedia Commons · Newsreels searched on YouTube",
  mediaPhotos: "Photographs",
  mediaNewsreels: "Newsreels",
  mediaOpenSource: "Open Commons ↗",
  mediaWatchPathe: "Watch on British Pathé ↗",
  mediaWatchYoutube: "Search on YouTube ↗",
  mediaNoImages: "No photographs indexed for this day yet — try the newsreels below.",
  mediaLoading: "Rummaging the archives…",
  mediaCredit: "Credit",
  mediaLicense: "License",
  mediaSlideshow: "Play Slideshow",
  mediaSlideshowHint: "Ken-Burns cycle · press space to pause · esc to close",
  radioBulletin: "Radio Bulletin",
  onAir: "On Air",
  playBulletin: "Play Bulletin",
  rolling: "Rolling…",
  pause: "Pause",
  resume: "Resume",
  bulletinHint: "A 20-second read of the top headlines & the day's #1 song",
  endOfEdition: "— End of Edition —",
  assembledBy: "Assembled by the Time Jump Bureau",
  edition: "Edition",
  volume: "Vol.",
  price: "Price: One Nickel",
  storyByline: "Staff Report",
  by: "by",
  shareTitle: "Share Your Snapshot",
  shareLinkLabel: "Shareable link (rich preview on Twitter/Slack/WhatsApp)",
  copy: "Copy",
  tweet: "Tweet",
  previewCard: "Preview card: 1200×630 · auto-generated",
  downloadPng: "Download PNG",
  preparing: "Preparing…",
  close: "Close ✕",
};

export const AR = {
  frontPage: "الصفحة الأولى",
  weather: "الطقس",
  onTheWire: "على البرق",
  chartFallback: "أغاني الأسبوع",
  atCinema: "في السينما",
  onTheTube: "في التلفزيون",
  watchTrailer: "شاهد الفيلم كاملاً",
  watchClip: "شاهد الحلقات",
  whereToStream: "جرّب على شاهد",
  aboutFilm: "عن الفيلم",
  onTheShelf: "على الرف",
  ambient: "من حولنا",
  gasPrice: "سعر البنزين",
  slangOfDay: "كلمة اليوم",
  soundtrack: "▶ ألحان اليوم",
  soundtrackHint: "أفضل ٣ — اضغط للاستماع",
  nowPlaying: "الآن يُذاع — الأولى في الأسبوع",
  openSpotify: "افتح في سبوتيفاي ↗",
  listen: "استمع ↗",
  search: "ابحث ↗",
  backToDesk: "العودة إلى المكتب",
  reprint: "إعادة الطباعة",
  share: "شارك اللقطة",
  media: "الأرشيف",
  mediaTitle: "نشرات وصور من الأرشيف",
  mediaHint: "صور من ويكيبيديا كومنز · نشرات إخبارية عبر البحث على يوتيوب",
  mediaPhotos: "الصور",
  mediaNewsreels: "النشرات الإخبارية",
  mediaOpenSource: "افتح على كومنز ↗",
  mediaWatchPathe: "شاهد على بريتيش باتيه ↗",
  mediaWatchYoutube: "ابحث على يوتيوب ↗",
  mediaNoImages: "لا توجد صور مفهرسة لهذا اليوم — جرّب النشرات أدناه.",
  mediaLoading: "نبحث في الأرشيف…",
  mediaCredit: "المصور",
  mediaLicense: "الترخيص",
  mediaSlideshow: "تشغيل الشرائح",
  mediaSlideshowHint: "عرض متتابع · مسافة للإيقاف · Esc للإغلاق",
  radioBulletin: "نشرة الإذاعة",
  onAir: "على الهواء",
  playBulletin: "تشغيل النشرة",
  rolling: "جارٍ التسجيل…",
  pause: "إيقاف مؤقت",
  resume: "استئناف",
  bulletinHint: "قراءة قصيرة لأبرز الأخبار وأغنية الأسبوع الأولى",
  endOfEdition: "— نهاية العدد —",
  assembledBy: "من مكتب القفزة الزمنية",
  edition: "طبعة",
  volume: "المجلد",
  price: "الثمن: قرش واحد",
  storyByline: "تحرير الجريدة",
  by: "بقلم",
  shareTitle: "شارك لقطتك",
  shareLinkLabel: "رابط للمشاركة (معاينة غنية على تويتر وسلاك وواتساب)",
  copy: "نسخ",
  tweet: "تغريدة",
  previewCard: "بطاقة المعاينة: ١٢٠٠×٦٣٠ · مُولَّدة تلقائيًا",
  downloadPng: "تنزيل الصورة",
  preparing: "جارٍ التحضير…",
  close: "إغلاق ✕",
};

export function getStrings(language) {
  return (language || "").toLowerCase() === "arabic" ? AR : EN;
}

export function isRTL(language) {
  return (language || "").toLowerCase() === "arabic";
}

// Detect Arabic script by scanning a text sample (Unicode U+0600–U+06FF range).
export function containsArabic(text) {
  if (!text || typeof text !== "string") return false;
  return /[\u0600-\u06FF]/.test(text);
}

// Given a snapshot object, decide if it should render as Arabic RTL.
// Fallback for legacy cached snapshots where region.language wasn't stored.
export function detectRTLFromSnapshot(snapshot, region) {
  if (isRTL(region?.language)) return true;
  // Snapshot content scan as fallback
  const s = snapshot || {};
  const samples = [
    s.headline_dateline,
    s.front_page_quote,
    s.news?.[0]?.headline,
    s.weather?.condition,
    s.sign_off,
  ];
  return samples.some((x) => containsArabic(x));
}

export function detectLanguageFromSnapshot(snapshot, region) {
  return detectRTLFromSnapshot(snapshot, region) ? "Arabic" : (region?.language || "English");
}
